<section *ngIf="loaded == 1" class="pdt40" fxLayoutAlign="center center">
    <div class="cw">

        

        <div class="fw centertext">
            <mat-icon class="gray-4 linkIcon ftxxxl">school</mat-icon>
            <h6 class="ft500 ft16">Mis cursos</h6>
        </div>

        <!-- <h6>Mis cursos</h6> -->
        <div fxLayout="row" fxLayoutAlign="center" class="mgt20" fxShow="true" fxShow.lt-md="false">
            <div fxLayout="column" fxFlex="70%">
                <div fxLayout="column" fxLayoutAlign="space-between" *ngFor="let item of cursosInfo;  let i=index"
                    class="border mgt10 mgb10 radius3 pdr10 shadow8">
                    <div fxLayout="row" fxLayoutGap="1.5rem" routerLink="/est/mi-curso/{{this.ids[i]}}"
                        class="cursorPointer">
                        <div>
                            <img [src]=item.foto class="avatarSquare9 radius3">
                        </div>
                        <div class="pdt10 pdb05" fxLayout="column" fxLayoutAlign="space-between" fxFlex="100%">
                            <div>
                                <a class="default-font-color ft14 ft500">{{item.titulo}} </a>
                                <p class="ft12">{{item.resumen}}</p>
                            </div>

                            <div class="mgb05" fxLayout="row" fxLayoutAlign=" center">

                                <span class="chip gray-8">{{item.instructorNombre}}</span>
                                <span *ngIf="item.empresaNombre" class="mgl10 chip gray-8">{{item.empresaNombre}}</span>


                                <mat-icon class="mgl10 linkIcon gray-6 mgr05 ft18">access_time</mat-icon>
                                <span class="gray-8 ft11 nowrap">{{item.duracion/60 | number:'1.0-1'}} h </span>

                            </div>
                            <!-- <div class="pdb05">
                                <mat-progress-bar mode="determinate" value="{{item.porcentajeCompletado}}">
                                </mat-progress-bar>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div *ngFor="let item of cursosInfo;  let i=index" fxShow="false" fxShow.lt-md="true">
            <div routerLink="/est/mi-curso/{{this.ids[i]}}"  ngClass.lt-md="mgt20 mgb10 border radius3 shadow8"
                fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="2rem" class="cursorPointer">
                <div fxLayout="row" fxLayoutGap="1rem" fxFlex="90%" fxFlex.lt-md="100%">
                    <img [src]=item.foto class="fotoDestacada2">
                    <div class="pdt08 pdb10 fw">
                        <h6 class="ft13 ft500 mgt0 mgb0 mgr05">
                            {{item.titulo}}
                        </h6>
                        <p class="mgt0 mgb0 ft11 mgr05">{{item.resumen}} </p>
                    </div>
                </div>
            </div>
        </div>

    </div>


</section>
<section *ngIf="loaded == 0" class="pdt40" fxLayoutAlign="center center">

    <div class="fw centertext">
        <mat-icon class="gray-4 linkIcon ftxxxl">school</mat-icon>
        <h6 class="ft500 ft16">Mis cursos</h6>
        
        <div fxLayout="column" fxLayoutAlign="center center">
            <br>
            <p class="centertext">No estas inscrito en ningun curso por los momentos</p>
            <button routerLink="/buscar" class="darkButton">Explorar cursos</button>
        </div>

    </div>
</section>